import {authLang as auth, commonLang as common, coreLang as core, wsLang as ws} from '@ft/core';

import {lang as products} from './products/i18n';
import {lang as file_manager} from './file-manager/i18n';
import {lang as printing} from './printing/i18n';
import {lang as ssh} from './ssh/i18n';
import {lang as db} from './databases-managers/i18n';
import {lang as shared_services} from './shared-services/i18n';

export let lang = Object.assign(
    {},
    {ws},
    {auth},
    {core},
    {common},
    {products},
    {file_manager},
    {ssh},
    {db},
    {printing},
    {shared_services},
    {
        shared: {
            copyright: '',
            cups_title: 'CUPS',
            no_sql_client_title: 'NoSqlClient',
            machine_code_copy_success: 'Code machine a été copié avec succès',
            cancel: 'Annuler',
            demo_use_license: 'DEMO USE LICENSE',

            restart: {
                planed_restart: 'Redémarrage planifié',
                title: 'Paramètres de redémarrage (- => disable)',
                cron_config: 'Paramètrage du CRON',
                config_success: 'Paramètres de redémarrage modifiés avec succès',

                reboot_device: 'Redémarrer la machine',
                shutdown_device: 'Éteindre la machine',

                reboot_confirm: 'Êtes-vous sûr de vouloir <strong style="color: var(--ft-warn-color)">redémarrer la machine</strong> ?',
                shutdown_confirm: 'Êtes-vous sûr de vouloir <strong style="color: var(--ft-warn-color)">éteindre la machine</strong> ?'
            }
        }
    }
);
